<template>
	<div>
		<v-autocomplete
				v-model="model"
				:items="entries"
				:loading="is_loading"
				:search-input.sync="search"
				hide-no-data
				hide-selected
				item-text="label"
				item-value="id"
				label="Course name or code"
				placeholder="Start typing to search"
				return-object
				attach
				solo
				:outline="is_mobile"
				flat
				@input="onInput"
				class="h-contact-us-input"
		></v-autocomplete>
	</div>
</template>

<script>
	import Axios from 'axios';
	import _ from 'lodash';

	export default {
		name: "SearchCourse",

		data() {
			return {
				entries: [],
				is_loading: false,
				model: null,
				search: null
			};
		},

		watch: {
			'search': _.debounce(function (val) {
				const self = this;
				// this.entries = [];

				if (!val) {
					self.model = null;
					return;
				}

				if (val.length < 3 || self.model) {
					return;
				}

				self.is_loading = true;
				Axios.get('/service/customer_help/rest/index.php/customer_help/search_courses?q=' + val).then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.entries = _.map(response.data['data'], function (x) {
							x['label'] =
								'('+ x['code'] + (x['section'] ? ' ' + x['section'] : '') + ') '
								+ x['name']
								+ (x['user_name'] ? ', ' + x['user_name'] : '');
							return x;
						});
					}
				}).finally(function(x) {
					self.is_loading = false;
				});

			}, 300)
		},

		methods: {
			onInput() {
				this.$emit('selected', this.model);
			}
		}


	}
</script>

<style scoped>

</style>